import React from 'react'
import './About.css'

export default function Section3() {
    return (
        <div className='min-h-screen flex items-center py-5'>
            <div className='w-[90%] mx-auto bg-[#0e0d12] backdrop-blur-[50px] p-5 md:p-14 lg:p-10 border border-white/10 text-center rounded-3xl flex flex-col lg:flex-row justify-center gap-5'>
                <div className='w-[100%] lg:w-1/4 space-y-7'>
                    <div className='reg-goal bg-[#191934] p-7 rounded-3xl grid content-center'>
                        <div className='flex justify-center'>
                            <h1 className='how-GD-header text-3xl font-bold bg-gradient-to-r bg-clip-text text-transparent from-[#F5F1FF] to-[#6633EE]'>Register <br className='hidden lg:block'/>for the<br className='hidden lg:block'/> Ultimate<br className='hidden lg:block'/> Kick-off</h1>
                        </div>
                        <p className='how-GD-para mt-3'>This is where your journey to becoming a digitally enhanced athlete begins! </p>
                    </div>
                    <div className='tra-goal bg-[#191934] p-5 rounded-3xl'>
                        <div className='flex justify-center'>
                            <h1 className='how-GD-header text-3xl font-bold bg-gradient-to-r bg-clip-text text-transparent from-[#F5F1FF] to-[#6633EE]'>Track Your Performance</h1>
                        </div>
                        <p className='mt-1'>Monitor stats, fitness, and training progress.</p>
                    </div>
                    <div className='dn-goal bg-[#191934] p-5 rounded-3xl grid content-center'>
                        <div className='flex justify-center'>
                            <h1 className='how-GD-header text-3xl font-bold bg-gradient-to-r bg-clip-text text-transparent from-[#F5F1FF] to-[#6633EE]'>DNA Test</h1>
                        </div>
                        <p className='how-GD-para mt-3'>Uncover endurance, strength, and performance traits.</p>
                    </div>
                </div>
                <div className='space-y-7 relative'>
                    <div className='how-goaldex 2xl:w-[548px] bg-[#653AD8] p-7 rounded-3xl mx-auto'>
                        <h1 className='how-GD-header-big text-4xl lg:text-6xl md:mt-10 font-bold'>How Goaldex <br /> Works</h1>
                    </div>
                    <div className='flex flex-col md:flex-row justify-center gap-7'>
                        <div className='dna-report-goal bg-[#191934] py-5 rounded-3xl'>
                            <img src='/assets/others/dnareportlight.svg' className='w-20'></img>
                            <img src='/assets/others/dnareport.svg'></img>
                            <div className='flex justify-center px-5 mt-3'>
                                <h1 className='how-GD-header text-3xl font-bold bg-gradient-to-r bg-clip-text text-transparent from-[#F5F1FF] to-[#6633EE]'>DNA Reports</h1>
                            </div>
                            <p className='how-GD-para mt-3 px-5'>Get insights into your genetic strengths.</p>
                        </div>
                        <div className='fusion-goal bg-[#191934] py-5 rounded-3xl'>
                            <img src='/assets/others/fusionlight.svg' className='w-20 ml-auto'></img>
                            <img src='/assets/others/fusion.svg'></img>
                            <div className='flex justify-center px-5 mt-3'>
                                <h1 className='how-GD-header text-3xl font-bold bg-gradient-to-r bg-clip-text text-transparent from-[#F5F1FF] to-[#6633EE]'>Fusion</h1>
                            </div>
                            <p className='how-GD-para mt-3 px-5'>Merge performance and DNA for full potential.</p>
                        </div>
                    </div>
                    <div className='relative md:absolute md:top-[50%] md:-translate-y-[60%] md:left-[50%] md:-translate-x-[50%]'>
                        <img src='/assets/others/Codenumber.svg' className='absolute w-[230px] top-[50%] -translate-y-[50%] md:w-auto left-[50%] -translate-x-[50%] rounded-full' style={{ zIndex: 1, transform: 'scale(1.15)' }}></img>
                        <div className='w-[250px] bg-[#0e0d12] p-3 rounded-full mx-auto'>
                            <img src='/assets/others/About-ball.svg' className='ball-spin'></img>
                            <div className='ball-left-top'></div>
                            <div className='ball-left-bottom'></div>
                            <div className='ball-right-top'></div>
                            <div className='ball-right-bottom'></div>
                        </div>
                    </div>
                </div>
                <div className='lg:w-1/4 space-y-7'>
                    <div className='how-GD-join bg-[#191934] p-7 rounded-3xl'>
                        <button className='bg-[#110A2B] rounded-full p-[6px] cursor-pointer'>
                            <button className='how-GD-para cursor-pointer flex items-center gap-2 bg-[#5F33D6] rounded-full px-5 py-2'><img src='/assets/icon/magic.svg'></img> Join Now</button>
                        </button>
                    </div>
                    <div className='bg-[#191934] p-7 rounded-3xl h-[214px] grid content-center'>
                        <div className='flex justify-center'>
                            <h1 className='how-GD-header text-3xl font-bold bg-gradient-to-r bg-clip-text text-transparent from-[#F5F1FF] to-[#6633EE]'>Game on</h1>
                        </div>
                        <p className='how-GD-para mt-3'>Use Role-Based Access Control to decide what scouts and clubs can access.</p>
                    </div>
                    <div className='pla-goal bg-[#191934] p-7 rounded-3xl grid content-center'>
                        <div className='flex justify-center'>
                            <h1 className='how-GD-header text-3xl font-bold bg-gradient-to-r bg-clip-text text-transparent from-[#F5F1FF] to-[#6633EE]'>Player Passport </h1>
                        </div>
                        <p className='how-GD-para mt-3'>Your data is compiled into an NFT-powered Player Passport- your digital identity, showcasing your career milestones &  genetic insights .</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
